type TabCountProps = {
  readonly count: number;
};

/** A small count next to a tab's label; nothing when zero. */
export function TabCount({ count }: TabCountProps) {
  if (count === 0) return null;
  return <span className="text-xs text-muted-foreground tabular-nums">{count}</span>;
}
